<!-- 分类列表 -->
<template>
  <div>
    <div class="banner_classify" v-bind:style="{backgroundImage:'url(' + bannerBackground + ')'}"></div>
    <!-- 12集团VI/ 51原创作品/ 53经验分享-->
    <div
      class="classify_main classify_vi"
      v-if="classifyId=='12'||classifyId=='51'||classifyId=='53'"
    >
      <div class="classify_list">
        <ul class="classify_ul" @mouseenter="actived=true" @mouseleave="actived=false">
          <li v-if="classifyId=='12'">
            <a class="classify_ula" :class="{actived:activedIndex==-1}" @click="choose(-1,-1)">常用</a>
          </li>
          <li v-for="(item,index) in classifyDate.Children" :key="index">
            <!-- <router-link tag="a" class="classify_ula" to="/" v-if="item.Level==3">{{item.Name}}2</router-link>
            <div class="classify_ul2" v-if="item.Children.length>0">
              <router-link tag="span"  v-for="(item2,index) in item.Children" :key="index" to="/">{{item2.Name}}11111111111</router-link>
            </div>-->
            <a
              class="classify_ula"
              v-if="item.Level==3"
              :class="{actived:activedIndex==index}"
              @click="choose(item.Id,index)"
            >{{item.Name}}</a>
            <div class="display" :class="{actived:actived}">
              <div class="classify_ul2" v-if="activedIndex==index">
                <span
                  v-for="(item2,index2) in item.Children"
                  :class="{actived:index==activedIndex&&index2==activedIndex2}"
                  :key="index2"
                  @click="radio(item2.Id,index2)"
                >{{item2.Name}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 14动漫素材 新  设计院图片资料--> 
    <div
      class="classify_main classify_vi" v-if="classifyId=='14' ||classifyId=='340'">
      <div class="classify_list">
        <ul class="classify_ul" @mouseenter="actived=true" @mouseleave="actived=false">
          <li v-for="(item,index) in classifyDate.Children" :key="index">
            <!-- <router-link tag="a" class="classify_ula" to="/" v-if="item.Level==3">{{item.Name}}2</router-link>
            <div class="classify_ul2" v-if="item.Children.length>0">
              <router-link tag="span"  v-for="(item2,index) in item.Children" :key="index" to="/">{{item2.Name}}11111111111</router-link>
            </div>-->
            <a
              class="classify_ula"
              v-if="item.Level==3"
              :class="{actived:activedIndex==index}"
              @click="choose(item.Id,index)"
            >{{item.Name}}</a>
            <div class="display" :class="{actived:actived}">
              <div class="classify_ul2" v-if="activedIndex==index" style="z-index:1001;">
                <span
                  v-for="(item2,index2) in item.Children"
                  :class="{actived:index==activedIndex&&index2==activedIndex2}"
                  :key="index2"
                  @click="radio(item2.Id,index2)"
                >{{item2.Name}}</span>
              </div>
              </div>
          </li>
        </ul>
      </div>
      <div class="classify_ul3" style="display:block;position:relative;top:0;">
                <ul class="classify_ul3_main">
                  <li  v-if="classifyId=='14'">
                    <b>筛选条件：</b>
                    <label
                      v-for="(item,index) in selectLabel"
                      :key="'selectLabel'+index"
                      @click="newestHot(item.label2,index,!item.flag)"
                    >
                      <input type="checkbox" v-model="item.flag" />
                      {{item.label1}}
                    </label>
                    <em></em>
                    <label
                      v-for="(item,index) in imgType"
                      :key="index"
                      @click="selectRes(item.label2,index,!item.flag)"
                    >
                      <input type="checkbox" v-model="item.flag" />
                      {{item.label1}}
                    </label>
                  </li>
                   <li v-if="labelFlag"  v-for="(item3,index3) in classifyDateC.Children" :key="index3" >
                    <b>{{item3.Name}}：</b>
                    <label
                      v-for="(item4,index4) in item3.Children"
                      :key="index4"
                      @click="multipleSelection(item3.Id,item4.Id,!item4.flag)"
                    >
                      <input type="checkbox" v-model="item4.flag" />
                      {{item4.Name}}
                    </label>
                  </li> 
                </ul>
              </div>
    </div>

    <!-- 13主题乐园素材/ 15版权照片 -->
    <div class="classify_main classify_vi" v-if="classifyId=='13'||classifyId=='15'">
      <div class="classify_list">
        <ul class="classify_ul" @mouseenter="actived=true" @mouseleave="actived=false">
          <li v-for="(item,index) in classifyDate.Children" :key="index">
            <!-- <router-link tag="a" class="classify_ula" to="/">{{item.Name}}111</router-link> -->
            <a
              class="classify_ula"
              :class="{actived:activedIndex==index}"
              @click="choose(item.Id,index)"
            >{{item.Name}}</a>
            <div class="display" :class="{actived:actived}">
              <div class="classify_ul3" v-if="activedIndex==index">
                <ul class="classify_ul3_main">
                  <li>
                    <b>筛选条件：</b>
                    <label
                      v-for="(item,index) in selectLabel"
                      :key="'selectLabel'+index"
                      @click="newestHot(item.label2,index,!item.flag)"
                    >
                      <input type="checkbox" v-model="item.flag" />
                      {{item.label1}}
                    </label>
                    <em></em>
                    <label
                      v-for="(item,index) in imgType"
                      :key="index"
                      @click="selectRes(item.label2,index,!item.flag)"
                    >
                      <input type="checkbox" v-model="item.flag" />
                      {{item.label1}}
                    </label>
                  </li>
                  <li v-for="(item2,index2) in item.Children" :key="index2">
                    <b>{{item2.Name}}：</b> 
                    <label
                      v-for="(item3,index3) in item2.Children"
                      :key="index3"
                      @click="multipleSelection(item2.Id,item3.Id,!item3.flag)"
                    >
                      <input type="checkbox" v-model="item3.flag" />
                      {{item3.Name}}
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>



    <!-- 乐园专题图片--旧 -->
    <div class="classify_main classify_vi" v-if="classifyName=='乐园专题图片--旧'">
      <div class="classify_list" style="padding-top:25px;">
        <div class="select_div">
          <img src="../../assets/img/select_div.png" />
          <select class="select_ly" @change="getCouponSelected" v-model="couponSelected">
            <option value="{'index':-1,'id':''}" selected="selected">全部主题乐园</option>
            <option
              v-for="(item,index) in classifyDate.Children"
              :key="index"
              :value="{'index':index,'id':item.Id}"
            >{{item.Name}}</option>
          </select>
        </div>
        <div class="classify_ul3" v-if="couponSelected.index>=0">
          <ul
            class="classify_ul3_main"
            v-for="(item,index) in classifyDate.Children"
            :key="index"
            v-if="couponSelected.index==index"
          >
            <li>
              <b>筛选条件：</b>
              <label
                v-for="(item,index) in selectLabel"
                :key="'selectLabel'+index"
                @click="newestHot(item.label2,index,!item.flag)"
              >
                <input type="checkbox" v-model="item.flag" />
                {{item.label1}}
              </label>
              <em></em>
              <label
                v-for="(item,index) in imgType"
                :key="index"
                @click="selectRes(item.label2,index,!item.flag)"
              >
                <input type="checkbox" v-model="item.flag" />
                {{item.label1}}
              </label>
            </li>
            <li>
              <b>标签：</b>
              <label
                v-for="(item2,index2) in item.ListLabel"
                :key="index2"
                @click="labelFilter(item2.Id,!item2.flag)"
              >
                <input type="checkbox" v-model="item2.flag" />
                {{item2.Name}}
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 17乐园专题图片--新 -->
    <div class="classify_main classify_vi" v-if="classifyId=='17'">
      <div class="classify_xcm">
        <ul class="classify_ul3_main">
          <li>
            <b>筛选条件：</b>
            <label
              v-for="(item,index) in selectLabel"
              :key="'selectLabel'+index"
              @click="newestHot(item.label2,index,!item.flag)"
            >
              <input type="checkbox" v-model="item.flag" />
              {{item.label1}}
            </label>
            <em></em>
            <label
              v-for="(item,index) in imgType"
              :key="index"
              @click="selectRes(item.label2,index,!item.flag)"
            >
              <input type="checkbox" v-model="item.flag" />
              {{item.label1}}
            </label>
          </li>
          <li>
            <b>主题乐园：</b>
            <label
              v-for="(item2,index2) in SystemLabel"
              :key="index2"
              @click="labelFilter(item2.Id,!item2.flag)"
            >
              <input type="checkbox" v-model="item2.flag" />
              {{item2.Name}}
            </label>
          </li>
          <li>
            <b>标　　签：</b>
            <label
              v-for="(item2,index2) in classifyDate.ListLabel"
              :key="index2"
              @click="labelFilter(item2.Id,!item2.flag)"
            >
              <input type="checkbox" v-model="item2.flag" />
              {{item2.Name}}
            </label>
          </li>
          <!-- 20191022临时修改备份：删除主题乐园（ID183）和项目（ID185）两个分类；主题乐园采用后台定义标签，临时写死在页面上，标签用前台自定义标签
            <li v-for="(item2,index2) in classifyDate.Children" :key="index2">
            <b>{{item2.Name}}：</b>
            <label
              v-for="(item3,index3) in item2.ListLabel"
              :key="index3"
              @click="labelFilter(item3.Id,!item3.flag)"
            >
              <input type="checkbox" v-model="item3.flag" />
              {{item3.Name}}
            </label>
          </li> -->
        </ul>
      </div>
    </div>

    <!-- 18熊出没专题图片/ 19免版权素材/ 211集团PPT/ 212PPT模板-->
    <div
      class="classify_main classify_vi"
      v-if="classifyId=='18'||classifyId=='19'||classifyId=='211'||classifyId=='212'"
    >
      <div class="classify_xcm">
        <ul class="classify_ul3_main">
          <li>
            <b>筛选条件：</b>
            <label
              v-for="(item,index) in selectLabel"
              :key="'selectLabel'+index"
              @click="newestHot(item.label2,index,!item.flag)"
            >
              <input type="checkbox" v-model="item.flag" />
              {{item.label1}}
            </label>
            <em></em>
            <label
              v-for="(item,index) in imgType"
              :key="index"
              @click="selectRes(item.label2,index,!item.flag)"
            >
              <input type="checkbox" v-model="item.flag" />
              {{item.label1}}
            </label>
          </li>
          <li>
            <b>标签：</b>
            <label
              v-for="(item2,index3) in classifyDate.ListLabel"
              :key="index3"
              @click="labelFilter(item2.Id,!item2.flag)"
            >
              <input type="checkbox" v-model="item2.flag" />
              {{item2.Name}}
            </label>
          </li>
        </ul>
      </div>
    </div>
    <!-- 16版权字库      -->
    <div class="classify_main classify_vi" v-if="classifyId=='16'">
      <div class="classify_list">
        <ul class="classify_ul" @mouseenter="actived=true" @mouseleave="actived=false">
          <li v-for="(item,index) in classifyDate.Children" :key="index">
            <a
              class="classify_ula"
              v-if="item.Level==3"
              :class="{actived:activedIndex==index}"
              @click="choose(item.Id,index)"
            >{{item.Name}}</a>
            <div class="display" :class="{actived:actived}">
              <div class="classify_ul2" v-if="activedIndex==index">
                <span v-for="(item2,index) in item.Children" :key="index" to="/">{{item2.Name}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getClassifyData } from "../../assets/js/modules/classify";
export default {
  props: {
    classifyId: ""
  },
  data() {
    return {
      labelFlag:false,
      couponSelected: "{'index':-1,'id':''}",
      actived: false,
      activedIndex: "-1", //一级菜单选中，乐园专题图片index
      activedIndex2: "-1", //二级菜单选中
      classifyDate: [],
      classifyDateC:[],//适用于动漫素材的二级菜单点击后绑定数据的中间变量
      bannerBackground: "",
      classifyName: "",
      classifyLevel: "",
      selectLabel: [
        { label1: "最新", label2: "CreateTime", flag: false },
        { label1: "热门", label2: "Hot", flag: false }
      ],
      imgType: [
        { label1: "JPG", label2: "jpg", flag: false },
        { label1: "PNG", label2: "png", flag: false },
        { label1: "PSD", label2: "psd", flag: false }
      ],
      SystemLabel:[
        {Id: 674, Name: "方特欢乐世界", flag: false },
        {Id: 675, Name: "方特梦幻王国", flag: false },
        {Id: 676, Name: "方特东方神画", flag: false },
        {Id: 677, Name: "方特水上乐园", flag: false },
        {Id: 678, Name: "方特东盟神画", flag: false },
        {Id: 679, Name: "方特丝路神画", flag: false },
        {Id: 680, Name: "方特国色春秋", flag: false },
        {Id: 4416, Name: "方特东方欲晓", flag: false },
      ],

      ImgExtensType: [], //图片类型
      Sorting: [], //最新,热门
      ListArray: {
        ThirdLevelCatelogId: 0,
        FileClassify: 1,
        ImgExtensType: [],
        FourLevelCatelogId:"0",
        LabelIds: [],
        Sorting: "",
        MinClassifies:[]
      }
    };
  },
  created() {
    this.getClassifyData();
  },
  methods: {
    // 查是否存在该数组
    arrayCheck(array, obj) {
      var thatIndex = -1;
      array.forEach(function(item, index) {
        if (obj == item) {
          thatIndex = index;
        }
      });
      return thatIndex;
    },
    //绑定分类数据
    getClassifyData() {
      getClassifyData({
        Id: this.classifyId
      }).then(res => {
        this.classifyDate = res.data.Data || [];
        if (!this.classifyDate) return;
        this.bannerBackground = res.data.Data.BackgroundImg;
        this.classifyName = res.data.Data.Name;
        this.classifyLevel = res.data.Data.Level;
      });
    },
    //点击获取分类数据
    getClassifyDataClick(obj) {
      getClassifyData({
        Id: obj
      }).then(res => {
        this.classifyDateC = res.data.Data;
        if (!this.classifyDateC) return;
      });
    },
    //查询图片类型数据
    selectRes(obj, index, flag) {
      var index = this.arrayCheck(this.ListArray.ImgExtensType, obj);
      if (flag) {
        if (index == -1) {
          this.ListArray.ImgExtensType.push(obj);
        }
      } else {
        if (index > -1) {
          this.ListArray.ImgExtensType.splice(index, 1);
        }
      }

      this.$emit("getListArray", this.ListArray);
    },
    // 查询最新，热门数据
    newestHot(obj, index, flag) {
      var index = this.arrayCheck(this.Sorting, obj);
      if (flag) {
        if (index == -1) {
          this.Sorting.push(obj);
        }
      } else {
        if (index > -1) {
          this.Sorting.splice(index, 1);
        }
      }
      this.ListArray.Sorting = this.Sorting.join(",");
      this.$emit("getListArray", this.ListArray);
    },
    //一级选择
    choose(id, index) {
      this.labelFlag=false
      // if (index != this.activedIndex) {
        Object.assign(this.$data.ListArray, this.$options.data().ListArray);
        Object.assign(this.$data.imgType, this.$options.data().imgType);
        Object.assign(this.$data.selectLabel, this.$options.data().selectLabel);
        this.activedIndex = index;
        this.activedIndex2 = -1;
        this.ListArray.ThirdLevelCatelogId = id;
        this.$emit("getListArray", this.ListArray);
      // } else {
      // }
    },
    // 条件单项选择
    radio(id, index) {
      this.labelFlag=true;
      if (this.activedIndex2 == index) {
        this.activedIndex2 = "-1";
        this.ListArray.FourLevelCatelogId ="0";
      } else {
        this.activedIndex2 = index;
        this.ListArray.FourLevelCatelogId = id;
      }
      this.getClassifyDataClick(id);
      this.$emit("getListArray", this.ListArray);
    },
    //条件多项选择
    multipleSelection(ParentId,id, flag) {
      console.log(ParentId,id,flag);
      var MinClassifiesItem={
        Id: id,
        ParentId: ParentId
      }
      var IsIndex=-1;
     this.ListArray.MinClassifies.forEach((item,index)=>{
        if(item.Id==id){
         IsIndex=index;
         return   
        }
     })
      if (flag) {
        if(IsIndex<0){
          this.ListArray.MinClassifies.push(MinClassifiesItem);
        }
      } else {
        if(IsIndex>=0){
          this.ListArray.MinClassifies.splice(IsIndex, 1);
        } 
      }
      this.$emit("getListArray", this.ListArray);
    },
    //标签筛选
    labelFilter(id, flag) {
      var index = this.arrayCheck(this.ListArray.LabelIds, id);

      if (flag) {
        if (index == -1) {
          this.ListArray.LabelIds.push(id);
        }
      } else {
        if (index > -1) {
          this.ListArray.LabelIds.splice(index, 1);
        }
      }

      this.$emit("getListArray", this.ListArray);
    },
    // 选项卡
    getCouponSelected() {
      Object.assign(this.$data.ListArray, this.$options.data().ListArray);
      Object.assign(this.$data.imgType, this.$options.data().imgType);
      Object.assign(this.$data.selectLabel, this.$options.data().selectLabel);
      this.ListArray.ThirdLevelCatelogId = this.couponSelected.id;

      this.$emit("getListArray", this.ListArray);
    }
  },
  watch: {
    $route(to, from) {
      this.getClassifyData();
    }
  },
  mounted(){
    if(this.$route.query.ThirdLevelCatelogId&&this.$route.query.ThirdLevelCatelogId==255){
      this.activedIndex=0
    }
  }
};
</script>
<style scoped>
.banner_classify {
  width: 100%;
  height: 350px;
  background-position: center;
  background-repeat: no-repeat;
}
.classify_main {
  width: 100%;
  min-width: 1280px;
}
.classify_list {
  width: 100%;
  min-width: 1280px;
  color: #333;
  font-size: 18px;
  background-color: #fff;
  border-bottom: 1px solid #e7e7e7;
  height: 75px;
  line-height: 75px;
  position: relative;
}
.classify_ul {
  width: 100%;
  height: 100%;
  text-align: center;
}
.classify_ul li {
  padding: 0 30px;
  display: inline-block;
}
.classify_ul li > a {
  display: block;
  width: 100%;
  height: 71px;
  border-bottom: 4px solid #fff;
}

.classify_ul li > a.actived {
  border-bottom: 4px solid #6b95ff;
}
.classify_ul li > a:hover {
  border-bottom: 4px solid #6b95ff;
}
.classify_ul2 {
  position: absolute;
  top: 76px;
  left: 0;
  width: 100%;
  /* height: 65px; */
  line-height: 65px;
  text-align: center;
  font-size: 16px;
  color: #666;
  border-bottom: 1px solid #e7e7e7;
  background-color: #fff;
  overflow: hidden;
  z-index: 999;
}

.classify_ul li:hover .classify_ul2 {
  /* display: block; */
}
.classify_ul2 span {
  padding: 5px 10px;
  margin: 0 10px;
  transition: 0.5s;
  transition: 0.5s;
  cursor: pointer;
  background-color: #fff;
}
.classify_ul2 span:hover {
  background-color: #f1f1f1;
  border-radius: 20px;
}
.classify_ul2 span.actived {
  background-color: #f1f1f1;
  border-radius: 20px;
}
.classify_ul3 {
  display: none;
  position: absolute;
  top: 76px;
  left: 0;
  width: 100%;
  font-size: 16px;
  color: #666;
  border-bottom: 1px solid #e7e7e7;
  background-color: #fff;
  overflow: hidden;
  z-index: 999;
}
.classify_main:hover .classify_ul3 {
  display: block;
}
.classify_ul3_main {
  width: 1280px;
  margin: 0 auto;
}
.classify_ul3_main em {
  margin: 5px 30px 0 0;
  border-right: 1px solid #666;
  width: 1px;
  height: 20px;
}
.classify_ul3_main b {
  color: #333;
  font-size: 16px;
  display: inline-block;
  width: 120px;
}
.classify_ul3_main li {
  width: 100%;
  min-height: 60px;
  line-height: 60px;
  overflow: hidden;
  display: block;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  max-height: 140px;
}
.classify_ul3_main label {
  margin-right: 25px;
  color: #666;
  font-size: 14px;
  display: inline-block;
}
.classify_ul3_main label input {
  margin-right: 5px;
  border: 1px solid #e7e7e7;
  border-radius: 0;
}
.classify_ul3_main label input[type="checkbox"]:checked,
input[type="radio"]:checked {
  background-color: #6aa9ff;
}
a {
  cursor: pointer;
}
.display {
  display: none;
  height: 65px;
}
.display.actived {
  display: block;
}
.select_div {
  position: relative;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
  margin: 0 auto;
  width: 220px;
  height: 45px;
}
.select_div img {
  position: absolute;
  right: 20px;
  top: 18px;
  z-index: 100;
}
.select_ly {
  width: 100%;
  margin: 0 auto;
  display: block;
  padding: 10px 10px 10px 20px;
  color: #333;
  border: none;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>


// WEBPACK FOOTER //
// src/components/common/classify.vue